import React from "react";
import { ToggleKnob } from "../../../../common/ToggleRow";
import "./MissionHarness.css";

/**
 * One wake source block inside wake policy. The full header toggles the trigger; config fields
 * render below when enabled.
 */
export default function MissionWakeTriggerCard({
  icon: Icon,
  title,
  description,
  enabled = false,
  onEnabledChange,
  switchDisabled = false,
  children,
}) {
  const canToggle = !switchDisabled && typeof onEnabledChange === "function";

  const handleToggle = () => {
    if (!canToggle) return;
    onEnabledChange(!enabled);
  };

  const handleKeyDown = (event) => {
    if (!canToggle) return;
    if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      handleToggle();
    }
  };

  const cardClassName = [
    "mission-harness__wake-card",
    enabled ? "mission-harness__wake-card--enabled" : "",
    canToggle ? "mission-harness__wake-card--interactive" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={cardClassName}>
      <div
        className={
          enabled
            ? "mission-harness__wake-card-icon mission-harness__wake-card-icon--enabled"
            : "mission-harness__wake-card-icon"
        }
      >
        {Icon ? <Icon fontSize="small" /> : null}
      </div>
      <div className="mission-harness__wake-card-body">
        <div
          className="mission-harness__wake-card-header"
          role={canToggle ? "switch" : undefined}
          aria-checked={canToggle ? enabled : undefined}
          aria-disabled={switchDisabled}
          aria-label={canToggle ? `${title} ${enabled ? "on" : "off"}` : undefined}
          tabIndex={canToggle ? 0 : -1}
          onClick={handleToggle}
          onKeyDown={handleKeyDown}
        >
          <div className="mission-harness__wake-card-heading">
            <p className="mission-harness__wake-card-title">{title}</p>
            {description ? (
              <p className="mission-harness__wake-card-description">{description}</p>
            ) : null}
          </div>
          <div
            className={[
              "mission-harness__wake-switch",
              switchDisabled ? "mission-harness__wake-switch--disabled" : "",
            ]
              .filter(Boolean)
              .join(" ")}
            aria-hidden="true"
          >
            <ToggleKnob checked={enabled} />
          </div>
        </div>
        {enabled && children ? (
          <div className="mission-harness__wake-card-control">{children}</div>
        ) : null}
      </div>
    </div>
  );
}
